import BaseService from "src/packages/BaseService";

export default class GameDataService extends BaseService {
	static get className() {
		return "data/game";
	}
};
